import API from 'core/Api';
import { getUserInfo, setUserInfo } from './auth';

const updateArchiveCount = (): Promise<void> => {
  return API.get('archives/new-count')
    .then(res => {
      const {
        has_available_archives: hasAvailableArchives,
        available_undownloaded_archives_count: availableUndownloadedArchivesCount,
        in_progress_archives_count: inProgressArchivesCount,
        last_archive_expires_at: lastArchiveExpiresAt,
      } = res.data;

      const currentUserInfo = getUserInfo();
      setUserInfo({
        ...currentUserInfo,
        hasAvailableArchives,
        availableUndownloadedArchivesCount,
        inProgressArchivesCount,
        lastArchiveExpiresAt,
      });

      window.dispatchEvent(
        new CustomEvent('archiveCountUpdated', {
          detail: {
            hasAvailableArchives,
            availableUndownloadedArchivesCount,
            inProgressArchivesCount,
            lastArchiveExpiresAt,
          },
        })
      );
    })
    .catch(err => {
      throw err;
    });
};

export default updateArchiveCount;
